const authCodeKey = 'feishu_auth_code'
export const getFeishuAuthCode = () => localStorage.getItem(authCodeKey)
export const setFeishuAuthCode = (auth_code) => localStorage.setItem(authCodeKey, auth_code)
export const removeFeishuAuthCode = () => localStorage.removeItem(authCodeKey)
